@if (this.selectedTool) {
<ng-template
  #formular
  let-data
>
  <div class="row align-items-end mb-3">
    <div class="col-auto">
      <span
        class="d-block mb-1"
        i18n="@@name-title"
      >Name: </span>
      <input
        pInputText
        [(ngModel)]="data.key"
        (ngModelChange)="formularModelChange()"
        [ngModelOptions]="{ updateOn: 'blur' }"
        pSize="small"
      >
    </div>
    <div class="col-auto">
      <span
        class="d-block mb-1"
        i18n="@@is-optional-title"
      >Ist optional:</span>
      <p-selectbutton
        size="small"
        [options]="requiredOptions"
        [unselectable]="true"
        optionLabel="label"
        optionValue="value"
        [ngModel]="data.required"
        (ngModelChange)="setParamRequired(data, $event)"
      ></p-selectbutton>
    </div>
    <div class="col-auto">
      <span
        class="d-block mb-1"
        i18n="@@type-title"
      >Typ:</span>
      <p-selectbutton
        size="small"
        [options]="paramTypeOptions"
        [unselectable]="true"
        optionLabel="label"
        optionValue="value"
        [ngModel]="data.type"
        (ngModelChange)="setParamType(data, $event)"
      ></p-selectbutton>
    </div>
    @if (data.type === 'enum') {
    <div class="col">
      <span
        class="d-block mb-1"
        i18n="@@selection"
      >Auswahl:</span>
      <input
        pInputText
        type="text"
        placeholder="wert_1,wert_2,wert_3, ..."
        [value]="data.values.join(',')"
        (change)="enumValChanged(data,$event)"
      >
    </div>
    }
  </div>
  <span i18n="@@parameter-description">
    Beschreibe der KI, wofür dieser Parameter verwendet wird z.B.:<b><br>Das Wort, wonach gesucht werden
      soll</b>,
    <b>eine Person, die gefunden werden soll</b>, <b>Firma, zu der mehrere informationen geladen werden soll</b>
  </span>
  <p-inputgroup>
    <p-inputgroup-addon>
      <i
        class="ri-sparkling-fill text-primary"
        style="font-size: 1.2rem;"
      ></i>
    </p-inputgroup-addon>
    <input
      pInputText
      i18n-placeholder="@@description"
      placeholder="Beschreibung"
      [(ngModel)]="data.description"
      (ngModelChange)="formularModelChange()"
      [ngModelOptions]="{updateOn: 'blur'}"
      fluid
    >
  </p-inputgroup>
  @if (this.getSelectedParamState() === 'new') {
  <p-button
    styleClass="mt-2"
    size="small"
    (onClick)="this.addParamToList();"
  >
    <ng-template pTemplate="content">
      <i class="ri-add-fill"></i>
      <span i18n="@@add">Hinzufügen</span>
    </ng-template>
  </p-button>
  }
</ng-template>
<div class="row align-items-end">
  <div class="col">
    <h3
      class="mt-4"
      i18n="@@if-title"
    >
      Wenn:
    </h3>
  </div>
  <div class="col-auto">
    <app-skill-id-input
      [value]="this.selectedTool.skillId"
      (changed)="this.selectedTool.skillId = $event; this.rss.saveBotConfigField('toolConfigs')"
    ></app-skill-id-input>
  </div>
  <div class="col-auto text-end pe-0">
    <p-toggleswitch
      [(ngModel)]="this.selectedTool.enabled"
      (ngModelChange)="this.rss.saveBotConfigField('toolConfigs')"
    ></p-toggleswitch>
  </div>
</div>
<p-divider
  align="left"
  styleClass="mt-4 mb-1"
>
  <span
    class="text-muted small fw-semibold"
    i18n="@@ki-recognition"
  >KI-Erkennung</span>
</p-divider>
<div class="row align-items-center mt-3">
  <div class="col-3">
    <span i18n="@@trigger">Auslöser</span>
  </div>
  <div class="col">
    <p-inputgroup>
      <p-inputgroup-addon>
        <i
          class="ri-sparkling-fill text-primary"
          style="font-size: 1.2rem;"
        ></i>
      </p-inputgroup-addon>
      <input
        pInputText
        type="text"
        [(ngModel)]="this.selectedTool.description"
        [ngModelOptions]="{updateOn: 'blur'}"
        (ngModelChange)="this.rss.saveBotConfigField('toolConfigs')"
        fluid
      >
    </p-inputgroup>
  </div>
</div>
<div class="row mt-3">
  <div class="col-3">
    <span i18n="@@functionname">Funktionsname</span>
    <app-hint i18n="@@function-name-hint">
      Bitte wähle für deinen Skill einen sprechenden bzw. aussagekräftigen (Funktions)-Namen.
      Es sind max. <b>30 Zeichen</b> für einen Namen zulässig, sowie ausschließlich folgende Zeichen:
      <b>a-z</b>, <b>A-Z</b>, <b>0-9</b>, <b>-</b> und <b>_</b>.
    </app-hint>
  </div>
  <div class="col">
    <app-function-name-suggest
      [descriptionString]="this.selectedTool.description"
      (finish)="this.onNameFinish($event)"
    >
      <input
        pInputText
        type="text"
        maxlength="30"
        [(ngModel)]="this.selectedTool.name"
        [ngModelOptions]="{updateOn: 'blur'}"
        (ngModelChange)="this.onNameChange(this.selectedTool.name)"
        fluid
      />
    </app-function-name-suggest>
  </div>
</div>

<h3
  class="mt-4"
  i18n="@@then-title"
>Dann:</h3>
<div class="mt-2">
  <p-tabs value="classicAnswers">
    <p-tablist>
      <p-tab value="classicAnswers">
        <i class="ri-chat-ai-line me-2"></i>
        <span i18n="@@default-answers">Standardantworten</span>
      </p-tab>
      <p-tab value="codeAction">
        @if (!this.selectedTool.detectedErrors) {
        <i class="ri-code-box-fill me-2"></i>
        }
        @if (this.selectedTool.detectedErrors) {
        <i class="ri-file-damage-fill text-danger me-2"></i>
        }
        <span i18n="@@execute-code-action">Code-Aktion ausführen</span>
      </p-tab>
      <p-tab value="variablesTab">
        <span i18n="@@variables">Variablen</span>
      </p-tab>
    </p-tablist>
    <p-tabpanels>
      <!-- STANDARDANTWORTEN -->
      <p-tabpanel value="classicAnswers">
        <div class="row mb-2">
          <div class="col-auto">
            <p-menu
              #answerMenu
              appendTo="body"
              [baseZIndex]="9000"
              [model]="toolAnswerMenuItems"
              [popup]="true"
            ></p-menu>
            <p-button
              severity="secondary"
              [outlined]="true"
              size="small"
              [style]="{ 'min-width': '300px' }"
              (onClick)="openToolAnswerMenu($event, answerMenu)"
            >
              <span
                style="min-width: 300px; display: inline-block;"
                class="text-start"
              >
                # ({{ this.toolCallAnswerShowIndex + 1 }} / {{ this.selectedTool.toolCallAnswer.length }}) |
                {{
                (this.selectedTool.toolCallAnswer[this.toolCallAnswerShowIndex]!.length > 30)
                ? (this.selectedTool.toolCallAnswer[this.toolCallAnswerShowIndex] | slice:0:30) + '...'
                : this.selectedTool.toolCallAnswer[this.toolCallAnswerShowIndex]
                }}
              </span>
            </p-button>
          </div>
          <div class="col p-0">
            @if (this.selectedTool.toolCallAnswer.length > 1) {
            <p-button
              severity="danger"
              [text]="true"
              size="small"
              styleClass="lock-sensitive"
              icon="ri ri-close-large-fill"
              label="Löschen"
              i18n-label="@@delete"
              (onClick)="this.deleteToolAnswerAtIndex(this.toolCallAnswerShowIndex)"
            ></p-button>
            }
          </div>
          @if (this.selectedTool.toolCallAnswer.length > 1) {
          <div
            class="col-auto pt-1"
            i18n="@@selection-mode"
          >
            Auswahlmodus
          </div>
          <div class="col-auto">
            <p-select
              [options]="answerModeOptions"
              [(ngModel)]="this.selectedTool.answerMode"
              optionLabel="label"
              optionValue="value"
              class="lock-sensitive"
              [style]="{ 'min-width': '260px' }"
              (ngModelChange)="this.rss.saveBotConfigField('toolConfigs')"
            ></p-select>
          </div>
          }
        </div>
        <app-codemirror-ai
          [instruction]="this.selectedTool.toolCallAnswer[this.toolCallAnswerShowIndex] || ''"
          [placeholder]="this.examplePLaceholder"
          [rows]="13"
          (finish)="this.selectedTool.toolCallAnswer[this.toolCallAnswerShowIndex] = $event; this.rss.saveBotConfigField('toolConfigs')"
        ></app-codemirror-ai>
      </p-tabpanel>
      <!-- CODE ACTION -->
      <p-tabpanel value="codeAction">
        <p-button
          severity="primary"
          [outlined]="true"
          [gotoBlockly]="this.editorItemService.getEditorItemByUniqueId('ifthen_'+this.selectedTool.id)"
          label="Zum Scripting"
          i18n-label="@@to-scripting"
        ></p-button>
      </p-tabpanel>
      <!-- VARIABLEN -->
      <p-tabpanel value="variablesTab">
        <p-menu
          #paramMenu
          appendTo="body"
          [baseZIndex]="9000"
          [model]="this.paramMenuItems"
          [popup]="true"
        ></p-menu>
        <p-table
          [value]="this.selectedTool.params"
          [rowHover]="true"
          styleClass="p-datatable-sm"
        >
          <ng-template
            pTemplate="body"
            let-param
            let-rowIndex="rowIndex"
          >
            <tr [ngClass]="{ 'bg-selected-row': this.selectedParam === param }">
              @if (this.selectedParam !== param) {
              <td style="vertical-align: middle;">
                <b i18n="@@variable-title">Variable:</b> vars.{{ param.key }}
                ({{ param.type }}
                @if (param.type === 'enum' && param.values) {
                <span>
                  | {{ param.values.join(', ') }}
                </span>
                })
                @if (!param.required) {
                <span>optional</span>
                }
              </td>
              <td style="vertical-align: middle;">
                <span><i class="text-muted">{{ param.description }}</i></span>
              </td>
              }
              @if (this.selectedParam === param) {
              <td
                colspan="2"
                class="p-5"
              >
                <ng-template
                  [ngTemplateOutlet]="formular"
                  [ngTemplateOutletContext]="{ $implicit: this.selectedParam }"
                ></ng-template>
                <div class="mt-2"></div>
                @if (this.selectedParam === param) {
                <p-button
                  severity="primary"
                  (onClick)="this.selectedParamIndex = -1"
                  size="small"
                  label="Speichern"
                  i18n-label="@@save"
                ></p-button>
                }
              </td>
              }
              <td class="text-end">
                @if (this.selectedParam !== param) {
                <p-button
                  [text]="true"
                  severity="secondary"
                  [rounded]="true"
                  icon="ri ri-more-2-fill"
                  [raised]="true"
                  (onClick)="this.selectedParamIndex = -1; this.paramForNewForm = undefined; this.openParamMenu($event, rowIndex)"
                ></p-button>
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
        <div
          class="mb-3"
          [@.disabled]="true"
        >
          @if (this.selectedTool.params.length === 0) {
          <p-message
            severity="secondary"
            [closable]="false"
          >
            <span i18n="@@variables-description">
              Variablen dienen dazu, von der KI automatisch erfasst und anschließend an
              die festgelegte Dann-Bedingung übergeben zu werden. So können dynamische Werte flexibel in den
              Wenn-Dann-Regeln verarbeitet werden.
            </span>
          </p-message>
          }
        </div>
        <div class="row">
          @if (this.paramForNewForm) {
          <div
            class="col p-5"
            style="border-left: 4px solid #00A599;"
          >
            <ng-template
              [ngTemplateOutlet]="formular"
              [ngTemplateOutletContext]="{ $implicit: this.paramForNewForm }"
            >
            </ng-template>
          </div>
          }
          @if (!this.paramForNewForm) {
          <div class="col">
            <p-button
              severity="primary"
              size="small"
              icon="ri ri-add-fill"
              label="Neue Variable"
              i18n-label="@@add-variable"
              (onClick)="this.selectEmptyParam()"
            ></p-button>
          </div>
          }
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
}